import { atomWithLocalStorage } from "@/utils/jotai/atomStorage.ts";

/**
 * Remember last used API key for each API prefix (stored separately).
 *
 * For convenience, to avoid having to re-enter the API key.
 */
export const lastApiKeyAtom = atomWithLocalStorage<Record<string, string>>("lastApiKey2", {});
